// @material-ui/icons
import PhoneIphone from '@material-ui/icons/PhoneIphone'
import LaptopMac from '@material-ui/icons/LaptopMac'
import Info from '@material-ui/icons/Info'

import Neko21 from 'views/Neko21/Neko21.jsx'
import Sontaku from 'views/Sontaku/Sontaku.jsx'
import Yusha from 'views/Yusha/Yusha.jsx'
import Saga from 'views/Saga/Saga.jsx'
import Orekami from 'views/Orekami/index.jsx'
import Math from 'views/Math/index.jsx'
import LisToDon from 'views/LisToDon/LisToDon.jsx'
import PrivacyPolicy from 'views/PrivacyPolicy/PrivacyPolicy.jsx'
import Top from 'views/Top/Top.jsx'

const dashboardRoutes = [
  {
    path: '/math',
    sidebarName: 'のうトレRPG-ゆうしゃとさんすう-',
    navbarName: 'React Native 2019.10.10',
    icon: PhoneIphone,
    component: Math
  },
  {
    path: '/orekami',
    sidebarName: '君の目の前で万能になった俺が神になる',
    navbarName: 'React Native 2019.07.12',
    icon: PhoneIphone,
    component: Orekami
  },
  {
    path: '/saga',
    sidebarName: 'Battle SaGa History',
    navbarName: 'React Native 2018.11.20',
    icon: PhoneIphone,
    component: Saga
  },
  {
    path: '/yushaigai',
    sidebarName: '勇者以外生き返らない',
    navbarName: 'React Native 2018.08.10',
    icon: PhoneIphone,
    component: Yusha
  },
  {
    path: '/sontaku',
    sidebarName: '忖度ダンジョン',
    navbarName: 'React Native 2018.07.08',
    icon: PhoneIphone,
    component: Sontaku
  },

  {
    path: '/neko21',
    sidebarName: '最強のねこ21',
    navbarName: 'React Native 2018.07.02',
    icon: PhoneIphone,
    component: Neko21
  },

  {
    path: '/listodon',
    sidebarName: 'LisToDon',
    navbarName: 'React 2018.06.28',
    icon: LaptopMac,
    component: LisToDon
  },

  {
    path: '/privacy-policy',
    sidebarName: 'Privacy policy',
    navbarName: 'Privacy policy',
    icon: Info,
    component: PrivacyPolicy
  },
  {
    path: '/dashboard',
    sidebarName: 'Top',
    navbarName: 'HorieH Apps',
    component: Top
  },

  { redirect: true, path: '/', to: '/dashboard', navbarName: 'Redirect' }
]

export default dashboardRoutes
